export default "__VITE_ASSET__b3e24195__"